var siteHeader = vueIfExists({
  mixins: [win.toggleCollapse],
  el: '#option-nav',
  data: {
      active: false,
      visible: false,
      sharedState: store.state,
      menuChangeIcon: false
  },
  methods: {
      makeCall: function(event) {
        location.href = 'tel://'+event.target.textContent.replace(' ', '');
      },
      setCur: function(event) {
        var cur = event.target.getAttribute('data-currency');
        if (!cur) return;
        win.store.set('query.cur', cur);
        var encodedQ = $url.encodeQ(this.sharedState.query);
        $cookie.updatePrsCookie({q: encodedQ });
        location.href = $url.encodeVar( { q: encodedQ } , { url: location.href });
      },
      openModal: function(selected, event) {
          event.stopPropagation();
          var isMobile = Math.max(html.clientWidth, win.innerWidth || 0) < 768;

          this.visible = selected == this.active ? !this.visible : true;

          if (this.visible) {

              this.menuChangeIcon = false;
              this.active = selected;
              var menuItem = event.target;
              menuItem = menuItem.tagName == 'LI' ? menuItem : menuItem.parentElement;
              var arrowPos = this.arrowPos(menuItem);

              if ( !isMobile ) {
                  this.$refs.modal.style.left = arrowPos.modalLeft + 'px';
              }
              if (!this.sharedState.rtl) {
                this.$refs['modal-arrow'].style.left = arrowPos.arrowLeft +'px';
              } else {
                this.$refs['modal-arrow'].style.right = arrowPos.arrowRight +'px';                
              }

          }
          if ( selected == 'menu' ) {
            this.menuChangeIcon = !this.menuChangeIcon;
          }
          

      },
      closeModal: function(event) {
        this.visible = false;
      },
      arrowPos: function(menuItem){

          var navBarPos = this.$el.getBoundingClientRect(),
              menuItemPos = menuItem.getBoundingClientRect(),
              arrowWidth = 6,
              windowMargin = 40,
              pageWidth =  Math.max(html.clientWidth, win.innerWidth || 0),
              modalWidth = this.active == 'currency' ? 600 : 190,
              modalLeft = menuItemPos.left - navBarPos.left + (menuItemPos.width / 2) - (modalWidth / 2);

          if (modalLeft + modalWidth + navBarPos.left > pageWidth - windowMargin) {
            modalLeft = pageWidth - modalWidth - windowMargin - navBarPos.left;
          } else if (modalLeft + navBarPos.left < windowMargin) {
            modalLeft = windowMargin - navBarPos.left;
          } 
          return { 
            modalLeft: modalLeft,
            arrowLeft: menuItemPos.left  - navBarPos.left + (menuItemPos.width / 2) - arrowWidth,
            arrowRight: navBarPos.width - (menuItemPos.left  - navBarPos.left + (menuItemPos.width / 2) + arrowWidth)
          };

      }
    }

});
